import React, { Component } from 'react'
import './index.less'
import { inject, observer } from 'src/core/store'
import { setDocumentTitle, setUidToken, InitPage } from 'src/helper/tool'
import langM from './lang'
import { getlang, setlang } from 'src/helper/getlang'
import score from 'src/helper/score'
import { jumpToUser, jumpToRoom, jumpToFamily } from 'src/helper/webviewFun'
import forbidScroll from 'src/tools/forbidScroll'
import { toJS } from 'mobx'

import CD from '../../../component/CountDown'

@inject('store')
@observer

export default class extends Component {
  constructor(props) {
    super(props)
    this.familyStore = this.props.store.register('activity/cp-yes')
    setDocumentTitle('CP')
  }

  state = {
    lang: langM.ar,
    isShowRule: false,
    tabState: 2,
    cd: 0,
    rankList: [],
    top1: {},
    top2: {},
    top3: {},
    myRank: {},
    btHidden: false,
    txtHidden: ``,
    loduplost:false,
    language:"en",
  }

  async componentWillMount() {
    console.log(window.location,'-----789---------')
    let { language, sender, giftId, receiver } = this.props.location.query
    language =await getlang(language)
    // lang 文字对象
    // language 语言种类 (zh/ar/en)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    // await this.familyStore.GetUserInfoWeb(uid)
    await this.RunOnStart({ sender, giftId, receiver })
    // let cd = await this.familyStore.getCd()
    // let list = await this.familyStore.getRank()
    // console.log(list)
    // this.setState({
    //   cd: cd,
    //   rankList: list && list.list,
    //   top1: list && list.list[0],
    //   top2: list && list.list[1],
    //   top3: list && list.list[2],
    //   myRank: list && list.myFamilyRank
    // })

  }

  // 初始化/接口请求初始化
  RunOnStart = async ({ sender, giftId, receiver } = {}) => {
    await this.familyStore.GetInviteCP({ sender, giftId, receiver })
    this.setState(
      {
        btHidden: this.familyStore.data.inviteCP.inviteResult,
        loduplost:true,
      }
    )
    console.log('%c [ this.familyStore ]-67', 'font-size:13px; background:pink; color:#bf2c9f;', this.familyStore)
    console.log('%c [ this.state ]-69', 'font-size:13px; background:pink; color:#bf2c9f;', this.state)
    // console.log(111,this.familyStore.data.ddd)
    // console.log(222,toJS(this.familyStore.data.ddd))
    // 用户id
    // this.setState({
    //   uid: uid
    // })
  }

  componentDidMount() {

  }

  onChangeRule(state) {
    forbidScroll(state)
    this.setState({
      isShowRule: state
    })
  }

  onChangeTab(state) {
    this.setState({
      tabState: state
    })
  }

  headComp(img, head, name, id, gold, fId) {
    return (
      <div className="head-wrap">
        <div className="head-border">
          <div className="head-wear"
            onClick={() => jumpToFamily(fId)}
            style={{ backgroundImage: `url(${head})` }}></div>
          <div className="head-ava">
            <img src={img} alt="" />
          </div>
          <div className="head-info">
            <div className='name'>{name}</div>
            <div className='id'>ID:{id}</div>
            <div className='gold'>{score(gold)}</div>
          </div>
        </div>
      </div>
    )
  }

  userItemComp(index, rank, img, name, id, gold, fId) {
    return (
      <div className="user-item" key={index}>
        <div className="rank">{rank}</div>
        <div className="ava" onClick={() => jumpToFamily(fId)}>
          <div className="six"></div>
          <div className="ava-box1">
            <div className="ava-box2">
              <div className="ava-box3">
                <img src={img} alt="" />
              </div>
            </div>
          </div>
        </div>
        <div className="info">
          <div className="name">{name}</div>
          <div className="id">ID:{id}</div>
        </div>
        <div className="gold-img">
          <img src="/img/gold.png" alt="" />
          <div className="gold">{score(gold)}</div>
        </div>
      </div>
    )
  }

  handleClick = (hidden) => {
    console.log('%c [ hidden ]-142', 'font-size:13px; background:pink; color:#bf2c9f;', hidden)
    this.familyStore.GetInviteCPResult({ ...this.familyStore.data.inviteCP, inviteResult: hidden });
    this.setState({
      btHidden: true,
      txtHidden: hidden ? this.state.lang.isYes : this.state.lang.isNo
    });
    console.log('%c [ this.state ]-69', 'font-size:13px; background:pink; color:#bf2c9f;', this.state)
  }
  
  render() {
    let { loduplost } = this.state
    return (
      <div className='cp-yes'>
        <div className='content-box'>
          <div className='left-box'>
            <div className='avatar'>
              <img src={this.familyStore.data.inviteCP.senderAvatarUrl}></img>
            </div>
            <div className='name'>
              {this.familyStore.data.inviteCP.senderName}
            </div>
          </div>
          <div className='middle-box'>
            <div className='cb-box'>
              <img src={this.familyStore.data.inviteCP.giftIconUrl}></img>
            </div>
          </div>
          <div className='right-box'>
            <div className='avatar'>
              <img src={this.familyStore.data.inviteCP.receiverAvatarUrl}></img>
            </div>
            <div className='name'>
              {this.familyStore.data.inviteCP.receiverName}
            </div>
          </div>
        </div>
        <div className='msg-box-bg'>
          <div className={`msg-box ${this.state.language == 'ar' ? 'arlang' : ''}`}>
            {this.state.btHidden ? this.state.txtHidden : this.state.lang.def.replace("AAAAA", this.familyStore.data.inviteCP.senderName)}
          </div>
        </div>
        <div className={`bt-box ${this.state.btHidden ? 'btHidden' : ''}`}>
          {loduplost && <div className='bt-yes' onClick={() => this.handleClick(true)}>
            {this.state.lang.btYes}
          </div>}
          {loduplost && <div className='bt-no' onClick={() => this.handleClick(false)}>
            {this.state.lang.btNo}
          </div>}
        </div>
        <i className='love love1'></i>
        <i className='love love2'></i>
        <i className='love love3'></i>
        <i className='love love4'></i>


      </div>
    )
  }
}


// WEBPACK FOOTER //
// src/pages/activity/cp-yes/index.js